import { render, staticRenderFns } from "./SpecializationsManagement.vue?vue&type=template&id=7683e874"
import script from "./SpecializationsManagement.vue?vue&type=script&lang=js"
export * from "./SpecializationsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports